import React from "react";

import { useTranslate } from "@hooks/useTranslate";

import * as Styled from "./Heading.styled";

export const Heading: React.FC<
  Pick<React.ComponentPropsWithoutRef<"div">, "className">
> = ({ className }) => {
  const translate = useTranslate("batmaid_pwa_static_homepage");

  return (
    <Styled.Root className={className}>
      <Styled.Title>{translate("features_intro_heading_text")}</Styled.Title>
      <Styled.Subtitle>
        {translate("features_intro_heading_description")}
      </Styled.Subtitle>
    </Styled.Root>
  );
};
